/**
 * `CaseTeamMember` roster shapes — mirrors the backend contract
 * (backend/.../module/case_/api/dto/CaseTeamMemberView.java + the six `TeamRole` enum values,
 * docs/design/IB-51-case-team-design.md §2.1/§3.2).
 */

export const TEAM_ROLES = [
  'case_manager',
  'professional_services_consultant',
  'psc_lead',
  'technical_consultant',
  'financial_consultant',
  'other',
] as const

export type TeamRole = (typeof TEAM_ROLES)[number]

/**
 * Display labels for the six enum values (docs/design/IB-51-case-team-design.md §6).
 *
 * IB-345: aligned to the corrected canon Profile display names
 * (docs/design/role-model-reconciliation.md §1, `SecurityMatrixSeeder.java`) — `professional_services_
 * consultant`/`psc_lead`/`financial_consultant` were stale abbreviated labels, not distinct roles.
 */
export const TEAM_ROLE_LABEL: Record<TeamRole, string> = {
  case_manager: 'Case Manager',
  professional_services_consultant: 'Professional Services Consultant',
  psc_lead: 'Professional Services Consultant (Lead)',
  technical_consultant: 'Technical Consultant',
  financial_consultant: 'Financial Services Consultant',
  other: 'Other',
}

export interface CaseTeamMemberView {
  id: string
  caseId: string
  teamRole: TeamRole
  userId: string
  /** Resolved via the non-throwing `identity.api.UserApi.findById` — `null` for a missing/deleted user. */
  userName: string | null
  assignedBy: string
  assignedByName: string | null
  assignedAt: string
  /** `false` rows are history — never physically deleted (AC5). */
  active: boolean
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  version: number
}
